import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeUtils } from '../utils';

@Pipe({
  name: 'dateParser',
  pure: false,
})
export class DateParserPipe implements PipeTransform {
  transform(value: string): Date {
    if (!value) {
      return null;
    }

    return DateTimeUtils.parseStringToDate(value);
  }
}
